import { render, staticRenderFns } from "./beSettled.vue?vue&type=template&id=7ec22977&scoped=true&"
import script from "./beSettled.vue?vue&type=script&lang=js&"
export * from "./beSettled.vue?vue&type=script&lang=js&"
import style0 from "./beSettled.vue?vue&type=style&index=0&id=7ec22977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec22977",
  null
  
)

export default component.exports